export const commonOverlayOptions = {
  draggable: true,
  editable: true,
  fillColor: '#154a93',
  fillOpacity: 0.7,
  geodesic: true,
  strokeColor: '#154a93',
  strokeWeight: 3,
};

export const infoBubbleBottomPadding = 20;
export const infoBubbleMouseBuffer = 40;

export const EARTH_RADIUS_METERS = 6378137;
export const CIRCLE_SEGMENTS = 64;

export const DRAW_STYLES = {
  fillColor: '#154a93',
  fillOpacity: 0.35,
  outlineColor: '#154a93',
  outlineWidth: 3,
};

// Polygons get full vertex editing; circles/rectangles are move-only so they can't be distorted
// into a shape that no longer matches their bounds type.
export const FULL_EDIT_FLAGS = {
  feature: { draggable: true, coordinates: { midpoints: true, draggable: true, deletable: true } },
};
export const MOVE_ONLY_FLAGS = {
  feature: { draggable: true, coordinates: { midpoints: false, draggable: false, deletable: false } },
};

export const BUTTON_SIZE_PX = 34;

export const TOOLBAR_MODES = [
  { mode: null, icon: 'fa-hand', title: 'Pan' },
  { mode: 'circle', icon: 'fa-circle', title: 'Draw circle' },
  { mode: 'polygon', icon: 'fa-draw-polygon', title: 'Draw polygon' },
  { mode: 'rectangle', icon: 'fa-draw-square', title: 'Draw rectangle' },
];

// TerraDraw rejects features whose coordinates exceed this many decimal places, so saved-search
// bounds (full float precision) must be rounded to it before being added. Kept in sync with the
// adapter's coordinatePrecision.
export const COORDINATE_PRECISION = 9;
